import { showFormResult } from "./form-result-modal.js";

const form = document.querySelector("#contactForm");
const submitButton = form?.querySelector('button[type="submit"]');

const API_URL = "https://vikonna-turbota-tg-back-1.onrender.com";
const endpoint = "api/telegram/contact";

const phonePattern = /^\+?[1-9]\d{7,14}$/;

const nameInput = form.elements.name;
const phoneInput = form.elements.phone;
const commentInput = form.elements.comment;

["name", "phone", "comment"].forEach((field) => {
  form.elements[field].addEventListener("input", (e) => {
    e.target.setCustomValidity("");
  });
});

function validateForm(form) {
  nameInput.setCustomValidity("");
  phoneInput.setCustomValidity("");
  commentInput.setCustomValidity("");

  const name = nameInput.value.trim();
  const phone = phoneInput.value.trim();
  const message = commentInput.value.trim();

  if (name.length < 2) {
    nameInput.setCustomValidity("Введіть ім'я (мінімум 2 символи).");
    nameInput.reportValidity();
    return false;
  }

  if (!phonePattern.test(phone)) {
    phoneInput.setCustomValidity("Введіть коректний номер телефону.");
    phoneInput.reportValidity();
    return false;
  }

  return true;
}

form?.addEventListener("submit", async (event) => {
  event.preventDefault();

  if (!validateForm(form)) {
    return;
  }

  submitButton.disabled = true;
  form.setAttribute("aria-busy", "true");

  try {
    const response = await fetch(new URL(endpoint, API_URL), {
      method: "POST",
      body: JSON.stringify({
        name: nameInput.value,
        phone: phoneInput.value,
        comment: commentInput.value,
      }),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    const result = await response.json().catch(() => null);

    if (!response.ok || result?.success === false) {
      throw new Error(`Помилка надсилання: ${response.status}`);
    }

    form.reset();
    showFormResult("success");
  } catch (error) {
    console.error("Не вдалося надіслати форму:", error);
    showFormResult("error");
  } finally {
    submitButton.disabled = false;
    form.removeAttribute("aria-busy");
  }
});
